import Vue from 'vue';

export default () => {
  const _prop = {
    get: () => {
      return document.title;
    },
    set: (title: string) => {
      document.title = 'Maison365 Stijlquiz';
    },
  };

  Object.defineProperty(Vue, 'pageTitle', _prop);
  Object.defineProperty(Vue.prototype, '$pageTitle', _prop);
};
